<router-outlet></router-outlet>
<lib-screen-spinner spinnerId="app"></lib-screen-spinner>
